module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/companies/company-logo-22-7cc8d3ca80c662e791499a0efc6c405a.png";